import React from "react";
import { Parah } from "../ContentsStyles";

const TAC_1 = () => {
  return (
    <>
      <Parah>
        Your contract is with Talents Explore Limited, which is a company
        registered in the England with its registered office at 71 Benton Road,
        Ilford, IG1 4AS, UK, and company number 13169329.
      </Parah>
      <Parah>
        In short: The specific Talents Explore company that you have a contract
        with depends on where you are resident. If we say “Talents Explore”,
        “we” or “us” in these Terms, we are referring to that specific company
        unless we say otherwise.
      </Parah>
    </>
  );
};

export default TAC_1;
